<template>
	<div class="coupon-list-item" :class="{'disable': disabled}"  @click="goPath">
		<div class="label">
			<div class="label-desc"><span>{{ info.name }}</span></div>
			<span class="label-warning"  v-if="info.leftDays&&!disabled">剩余{{ info.leftDays }}天</span>
		</div>
		<div class="content">
			<div class="content-l">
				<template>
          <div class="content-l-price" v-if="info.type === 1"><span class="price-mark">¥</span><span class="price">{{ info.discount }}</span></div>
          <div class="content-l-price" v-else><span class="price">{{ info.discount }}</span><span class="price-discount">折</span></div>
				</template>				<div class="content-l-desc">
				<p>满{{ info.needOverAmount }}可用</p>
				<p class="sub-title">有效期至{{ info.endTime }}</p>
			</div>
			</div>
			<div class="content-r" v-if="!disabled">
				<span class="icon iconfont iconfanhui2"></span>
			</div>
		</div>
		<img class="close" src="../../../assets/img/member/close.png" v-if="disabled"  @click="deleteData"/>
		<img class="disable-img" src="../../../assets/img/member/disable.png" v-if="disabled && status === 2" />
		<img class="disable-img" src="../../../assets/img/member/expired.png" v-if="disabled && status === 3" />
	</div>
</template>

<script>
	import Toast from 'vant/es/toast';
	import { reqDeleteCoupon } from '../../../api';
	import { mapGetters, mapMutations } from 'vuex';

	export default {
		name: 'couponListItem',
		props: {
			info: {
				type: Object,
				default: ()=>{
					return {}
				}
			},
			status: {
				type: Number,
				default: 0
			}
		},
		created() {
		},
		computed: {
			...mapGetters(['notAvailableCouponNum','vipLevel']),
			disabled: {
				get() {
					return this.status===2||this.status===3 ? true :false
				},
				set() {}
			}
		},
		methods: {
			...mapMutations({
				setDiscoupon: 'SET_DISCOUPONNUMBER'
			}),
			goPath() {
				if(this.disabled){
					return
				}
				// 优惠券点击埋点
				// eslint-disable-next-line
				sensors.track('coupon_id', {
					coupon_id: this.info.id
				})
				let query = {
					vipLevel: this.vipLevel
				}
				this.$router.push({path: '/vip/vipjoin',query})
			},
			// 删除数据
			deleteData() {
				reqDeleteCoupon({id: this.info.id}).then(() => {
					Toast('删除成功')
					let num = this.notAvailableCouponNum - 1
					this.setDiscoupon(num)
					setTimeout(()=>{
						this.$emit('refresh')
					},1000)
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.coupon-list-item {
		width: 100%;
		height: 120px;
		margin-top: 21px;
		position: relative;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
		border-radius:5px;
		.label {
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			.label-desc {
				border-radius:5px 0px 5px 0px;
				background:linear-gradient(90deg,rgba(242,218,178,1) 0%,rgba(217,181,123,1) 100%);
				> span {
					display: inline-block;
					font-size: 12px;
					height: 27px;
					line-height: 27px;
					padding: 0px 10px;
					color: #7C561E;
				}
			}
			.label-warning {
				display: inline-block;
				margin-left: 10px;
				color: #FA5741;
				font-size: 12px;
				line-height: 27px;
			}
		}
		.close {
			position: absolute;
			top: 0;
			right: 0;
			width: 24px;
			height: auto;
		}
		.disable-img {
			position: absolute;
			right: 0;
			bottom: 0;
			width: 77px;
			height: auto;
		}
		.content {
			display: flex;
			height: 100%;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px 0 12px;
			&-l {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				.content-l-price {
					width: 93px;
					height:100%;
					color:rgba(250,87,65,1);
					display: flex;
					align-items: flex-end;
					justify-content: center;
					font-family: DINCondensedBold;
					.price-mark {
						font-size: 20px;
						line-height: .7;
					}
					.price-discount{
						font-size: 20px;
						line-height: .9;
					}
					.price{
						font-size:38px;
						line-height: .5;
					}
				}
				.content-l-desc {
					margin-left: 18px;
					display: flex;
					flex-direction: column;
					.sub-title {
						margin-top: 10px;
					}
				}
			}
			&-r {
				.iconfanhui2 {
					font-size: 12px;
					color: @lightBlack;
				}
			}
		}
	}
	.coupon-list-item.disable {
		.label {
			.label-desc {
				background:#eee;
				> span {
					color: @subBlack;
				}
			}
			.label-warning {
				color: @subBlack;
			}
		}
		.content-l {
			.content-l-price {
				color: @subBlack;
				> span {
					color: @subBlack;
				}
			}
			.content-l-desc {
				color: @subBlack;
				.sub-title {
					color: @subBlack;
				}
			}
		}
		.content-r {
			color: @subBlack;
		}
	}

</style>
